// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c9671352","453":"b1a5a552","732":"181eee27"}[chunkId] + ".chunk.js";
};